<template>
  <div>
    <multiselect
        :id="id"
        v-model="selected"
        :options="options"
        :multiple="true"
        label="name"
        :searchable="true"
        :clear-on-select="false"
        :close-on-select="false"
        track-by="code"
        placeholder="Favorite countries"
    >
    </multiselect>
    <input type="hidden" :value="defaultCountries" :name="name">
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"

export default {
  components: {
    Multiselect,
  },
  name: "country-selector",
  props: {
    countriesList: {
      type: Object,
      default: null,
    },
    id:{
      type: String,
      default: 'country-selector',
    },
    selectedCountries:{
      type: Array,
      default: () => [],
    },
    name:{
      type:String,
      default:'favoriteCountries',
    }
  },
  data() {
    return {
      options: [],
      selected:[],
    }
  },
  computed: {
    defaultCountries(){
      return this.selected.map((select) => select.code)
    }
  },
  methods: {
    fillOptionsWithCountries() {
      this.options = Object.entries(this.countriesList).map(
          ([code, name]) => ({code, name})
      )
    },
    fillSelectedCountries(){
      this.selectedCountries?.forEach((code) => {
        let country = this.options.find(element => element.code === code)
        if(country && !this.selected.find(element => element === country)){
          this.selected.push(country)
        }
      })
    }
  },
  mounted() {
    this.fillOptionsWithCountries();
    this.fillSelectedCountries();
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>